import React from 'react';
import Pylon3Board from './Pylon3Board';

const Pylon3RightLeg = () => {
  return <Pylon3Board legType="right" />;
};

export default Pylon3RightLeg;
